export default __webpack_public_path__ + "static/media/gmx_logo.7b0d3843.svg";